import { State } from "@/store/modules/apm/topology/topology.store";
import { getApdexColor } from "@/utils/helper-function";

const getters = {
	topoInfraRightStateGetter(state: State) {
		return state.topoInfraRightState;
	},
	topoOverviewLeftStateGetter(state: State) {
		return state.topoOverviewLeftState;
	},
	topoOverviewRightStateGetter(state: State) {
		return state.topoOverviewRightState;
	},
	topologyTableData(state: State) {
		let infraIds: any = [];
		state.nodes.forEach(item => {
			if (item.type === 'INFRA') {
				infraIds.push(item.id);
			}
		});
		var result = state.calls.map(el => {
			return {
				source: {
					name: el.source.name,
					isApdex: true,
					apdexColor:
						el.source.type === 'USER' ? 'blue' : getApdexColor(el.source.apdex),
				},
				target: {
					name: el.target.name,
					isApdex: true,
					apdexColor:
						el.target.type === 'USER'
							? 'blue'
							: el.target.type === 'INFRA'
							? 'infra'
							: !el.target.isReal
							? 'non-real'
							: getApdexColor(el.target.apdex),
				},
				cpm: el.detectPoints.length === 0 ? '-' : el.cpm,
				detectPoint:
					el.detectPoints.length < 1
						? el.detectPoints.length === 0
							? '-'
							: `${el.detectPoints[0]} | ${el.detectPoints[1]} `
						: el.detectPoints[0],
				responseTime: el.detectPoints.length === 0 ? '-' : el.latency,
				sourceType: el.source.isReal,
				targetType: el.target.isReal,
				infrastructure: infraIds.includes(el.target.id) ? el.target : false,
			};
		});
		return result;
	},
};

export default getters;
